module.exports = __webpack_public_path__ + "static/img/icon_logo.4e732ab1.png";